import './LitJewelleryOptions.svelte.css';
/* src/LitJewelleryOptions.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import DesignPanel from './components/JewelleryOptions/JewelleryOptionsDesign.svelte.js';
import StrapPanel from './components/JewelleryOptions/JewelleryOptionsStrap.svelte.js';

function create_else_block_1(ctx) {
	let t;

	return {
		c() {
			t = text("no-data");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (27:32) 
function create_if_block_2(ctx) {
	let h2;
	let t2;
	let strappanel;
	let current;
	strappanel = new StrapPanel({ props: { parts: /*parts*/ ctx[2] } });

	return {
		c() {
			h2 = element("h2");
			h2.innerHTML = `ストラップ無料オーダーメイド <span class="svelte-vwomi6">紐色・金具を選べます</span>`;
			t2 = space();
			create_component(strappanel.$$.fragment);
			attr(h2, "class", "svelte-vwomi6");
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			insert(target, t2, anchor);
			mount_component(strappanel, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const strappanel_changes = {};
			if (dirty & /*parts*/ 4) strappanel_changes.parts = /*parts*/ ctx[2];
			strappanel.$set(strappanel_changes);
		},
		i(local) {
			if (current) return;
			transition_in(strappanel.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(strappanel.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t2);
			destroy_component(strappanel, detaching);
		}
	};
}

// (21:1) {#if 'start' === viewType}
function create_if_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if ('home' === /*design*/ ctx[0].target) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (24:2) {:else}
function create_else_block(ctx) {
	let strong;

	return {
		c() {
			strong = element("strong");
			strong.textContent = "アイテムが見つかりません";
		},
		m(target, anchor) {
			insert(target, strong, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(strong);
		}
	};
}

// (22:2) {#if 'home' === design.target}
function create_if_block_1(ctx) {
	let designpanel;
	let current;

	designpanel = new DesignPanel({
			props: {
				design: /*design*/ ctx[0],
				jewelleryType: /*types*/ ctx[1]
			}
		});

	return {
		c() {
			create_component(designpanel.$$.fragment);
		},
		m(target, anchor) {
			mount_component(designpanel, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const designpanel_changes = {};
			if (dirty & /*design*/ 1) designpanel_changes.design = /*design*/ ctx[0];
			if (dirty & /*types*/ 2) designpanel_changes.jewelleryType = /*types*/ ctx[1];
			designpanel.$set(designpanel_changes);
		},
		i(local) {
			if (current) return;
			transition_in(designpanel.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(designpanel.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(designpanel, detaching);
		}
	};
}

function create_fragment(ctx) {
	let link;
	let t;
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block, create_if_block_2, create_else_block_1];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if ('start' === /*viewType*/ ctx[3]) return 0;
		if ('strap' === /*viewType*/ ctx[3]) return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			link = element("link");
			t = space();
			div = element("div");
			if_block.c();
			attr(link, "rel", "preload");
			attr(link, "as", "style");
			attr(link, "onload", "this.onload=null;this.rel='stylesheet'");
			attr(link, "href", "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;900&display=swap");
			attr(div, "class", "lit-jewellery-options");
		},
		m(target, anchor) {
			append(document.head, link);
			insert(target, t, anchor);
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			detach(link);
			if (detaching) detach(t);
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { design } = $$props;
	let { types } = $$props;
	let { parts } = $$props;
	let { viewType } = $$props;

	$$self.$$set = $$props => {
		if ('design' in $$props) $$invalidate(0, design = $$props.design);
		if ('types' in $$props) $$invalidate(1, types = $$props.types);
		if ('parts' in $$props) $$invalidate(2, parts = $$props.parts);
		if ('viewType' in $$props) $$invalidate(3, viewType = $$props.viewType);
	};

	return [design, types, parts, viewType];
}

class LitJewelleryOptions extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			design: 0,
			types: 1,
			parts: 2,
			viewType: 3
		});
	}
}

export default LitJewelleryOptions;